module.exports = __webpack_public_path__ + "media/images/icn-list-white-3ddf0a9c9c19b3865eda90566a4d3175.png";